<template lang="pug">
  .notice-block(:class="typeClass" data-test-id="lei-notice")
    .notice-content
      font-awesome-icon.icon(:icon="icon")
      span.text(v-html="text")
    .notice-action
</template>
<script>

export default {
  name: 'LeiNotice',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'info-circle',
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => [
        'info',
        'warning',
        'success',
        'danger',
      ].includes(value),
    },
  },
  computed: {
    typeClass () {
      return `notice-block_${this.type}`
    },
  },
}
</script>
<style lang="stylus" scoped>
@import "../../assets/styles/variables.styl"

.notice-block
  display flex
  justify-content flex-start
  padding 15px 15px
  border-radius 5px
  line-height 1.5rem
  margin-bottom 1em
  font-size 1rem
  &_info
    background $notice-info-color
  &_success
    background $notice-success-color
  &_warning
    background $notice-warning-color
  &_danger
    background $notice-danger-color
  @media screen and (max-width: $laptop)
    margin -25px 20px 40px 20px
  @media screen and (max-width: $tablet)
    margin 10px 1.2em
  .text >>> a
    color $default-color
    font-weight bold
    text-decoration underline
    &:hover
     color $turquoise-color 
.icon
  margin-right 10px
</style>



// WEBPACK FOOTER //
// src/components/lei-components/LeiNotice.vue